var map = {
	"./anxiang/news.png": "5H8H",
	"./default/news.png": "9Abh",
	"./huarong/news.png": "lslO",
	"./master/news.png": "qAbG",
	"./shaodong/news.png": "I8EU",
	"./taoyuan/news.png": "+4T5",
	"./yueyang/news.png": "epWQ",
	"./zhuzhou/news.png": "0Bwx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "R3Lm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/news\.png$
// module id = R3Lm
// module chunks = 1